import { useLocation } from "react-router-dom";

export const useIsPathActive = () => {
  const { pathname } = useLocation();
  return (path: string) => pathname === path || pathname.startsWith(`${path}/`);
};
